// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PostV1BankidAuthResponse, PostV1BankidCollectData, PostV1BankidCollectResponse, GetV1IndividualsByIndividualIdDocumentsData, GetV1IndividualsByIndividualIdDocumentsResponse, PostV1IndividualsByIndividualIdDocumentsData, PostV1IndividualsByIndividualIdDocumentsResponse, PostV1IndividualsByIndividualIdDocumentsMergeData, PostV1IndividualsByIndividualIdDocumentsMergeResponse, PostV1IndividualsByIndividualIdDocumentsByDocumentIdFilesData, PostV1IndividualsByIndividualIdDocumentsByDocumentIdFilesResponse, PostV1IndividualsByIndividualIdDocumentsByDocumentIdSplitData, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrderData, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrderResponse, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdData, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdResponse, DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdData, DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdResponse, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdData, PatchV1IndividualsByIndividualIdDocumentsByDocumentIdResponse, DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdData, PostV1IndividualsByIndividualIdDocumentsByDocumentIdCommitData, PostV1IndividualsByIndividualIdDocumentsByDocumentIdCommitResponse, PostV1IndividualsByIndividualIdDocumentsByDocumentIdPreChecksData, PostV1IndividualsByIndividualIdDocumentsByDocumentIdPreChecksResponse, DeleteV1IndividualsByIndividualIdDocumentsDraftsData, DeleteV1IndividualsByIndividualIdDocumentsDraftsResponse, GetV1IndividualsResponse, PostV1IndividualsData, PostV1IndividualsResponse, GetV1IndividualsByIndividualIdData, GetV1IndividualsByIndividualIdResponse, PatchV1IndividualsByIndividualIdData, PatchV1IndividualsByIndividualIdResponse, DeleteV1IndividualsByIndividualIdData, DeleteV1IndividualsByIndividualIdResponse, PostV1IndividualsByIndividualIdGenerateDescriptionData, PostV1IndividualsByIndividualIdGenerateDescriptionResponse, GetV1IndividualsByIndividualIdRegenStatusData, GetV1IndividualsByIndividualIdRegenStatusResponse, PostV1IndividualsByIndividualIdRegenerateData, PostV1IndividualsByIndividualIdRegenerateResponse, PatchV1IndividualsByIndividualIdRelationData, PatchV1IndividualsByIndividualIdRelationResponse, PostV1IndividualsByIndividualIdInviteUserData, PostV1IndividualsByIndividualIdInviteUserResponse, PostV1IndividualsByIndividualIdRevokeAccessData, PostV1IndividualsByIndividualIdRevokeAccessResponse, GetV1IndividualsByIndividualIdTimelineData, GetV1IndividualsByIndividualIdTimelineResponse, GetV1UsersMeResponse, PatchV1UsersMeData, PatchV1UsersMeResponse, GetV1IndividualsByIndividualIdThreadsData, GetV1IndividualsByIndividualIdThreadsResponse, PostV1IndividualsByIndividualIdThreadsData, GetV1IndividualsByIndividualIdThreadsByThreadIdData, GetV1IndividualsByIndividualIdThreadsByThreadIdResponse, DeleteV1IndividualsByIndividualIdThreadsByThreadIdData, PostV1IndividualsByIndividualIdThreadsByThreadIdSummerizeData, PostV1IndividualsByIndividualIdThreadsByThreadIdSummerizeResponse, GetV1IndividualsByIndividualIdNotesData, GetV1IndividualsByIndividualIdNotesResponse, PostV1IndividualsByIndividualIdNotesData, PostV1IndividualsByIndividualIdNotesResponse, PostV1IndividualsByIndividualIdNotesSearchData, PostV1IndividualsByIndividualIdNotesSearchResponse, GetV1IndividualsByIndividualIdNotesByNoteIdData, GetV1IndividualsByIndividualIdNotesByNoteIdResponse, PatchV1IndividualsByIndividualIdNotesByNoteIdData, PatchV1IndividualsByIndividualIdNotesByNoteIdResponse, DeleteV1IndividualsByIndividualIdNotesByNoteIdData, PatchV1IndividualsByIndividualIdNotesByNoteIdTitleData, PatchV1IndividualsByIndividualIdNotesByNoteIdTitleResponse, PatchV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdData, PatchV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdResponse, DeleteV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdData, DeleteV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdResponse, GetV1IndividualsByIndividualIdServiceGroupsData, GetV1IndividualsByIndividualIdServiceGroupsResponse, PostV1IndividualsByIndividualIdServiceGroupsByServiceGroupIdData, PostV1IndividualsByIndividualIdServiceGroupsByServiceGroupIdResponse, GetV1IndividualsByIndividualIdErrandsData, GetV1IndividualsByIndividualIdErrandsResponse, PostV1IndividualsByIndividualIdErrandsData, PostV1IndividualsByIndividualIdErrandsResponse, PatchV1IndividualsByIndividualIdErrandsByErrandIdData, PatchV1IndividualsByIndividualIdErrandsByErrandIdResponse, DeleteV1IndividualsByIndividualIdErrandsByErrandIdData, GetV1IndividualsByIndividualIdErrandsByErrandIdActionsData, GetV1IndividualsByIndividualIdErrandsByErrandIdActionsResponse, GetV1MunicipalitiesResponse, PostV1FeedbackData, PostV1FeedbackResponse, GetV1IndividualsByIndividualIdContactsData, GetV1IndividualsByIndividualIdContactsResponse, PostV1IndividualsByIndividualIdContactsData, PostV1IndividualsByIndividualIdContactsResponse, PostV1IndividualsByIndividualIdContactsMergeData, PostV1IndividualsByIndividualIdContactsMergeResponse, GetV1IndividualsByIndividualIdContactsByContactIdData, GetV1IndividualsByIndividualIdContactsByContactIdResponse, PatchV1IndividualsByIndividualIdContactsByContactIdData, PatchV1IndividualsByIndividualIdContactsByContactIdResponse, DeleteV1IndividualsByIndividualIdContactsByContactIdData, GetV1BillingPricesResponse, PostV1BillingCheckoutData, PostV1BillingCheckoutResponse, PostV1BillingPortalData, PostV1BillingPortalResponse } from './types.gen';

export class AuthService {
    /**
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static postV1BankidAuth(): CancelablePromise<PostV1BankidAuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bankid/auth'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static postV1BankidCollect(data: PostV1BankidCollectData): CancelablePromise<PostV1BankidCollectResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/bankid/collect',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class IndividualsService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns documentArray Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdDocuments(data: GetV1IndividualsByIndividualIdDocumentsData): CancelablePromise<GetV1IndividualsByIndividualIdDocumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/documents/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns documentUploadArray Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocuments(data: PostV1IndividualsByIndividualIdDocumentsData): CancelablePromise<PostV1IndividualsByIndividualIdDocumentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns document Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocumentsMerge(data: PostV1IndividualsByIndividualIdDocumentsMergeData): CancelablePromise<PostV1IndividualsByIndividualIdDocumentsMergeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/merge',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.requestBody
     * @returns documentUpload Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocumentsByDocumentIdFiles(data: PostV1IndividualsByIndividualIdDocumentsByDocumentIdFilesData): CancelablePromise<PostV1IndividualsByIndividualIdDocumentsByDocumentIdFilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/{documentId}/files',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.requestBody
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocumentsByDocumentIdSplit(data: PostV1IndividualsByIndividualIdDocumentsByDocumentIdSplitData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/{documentId}/split',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.requestBody
     * @returns document Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrder(data: PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrderData): CancelablePromise<PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesOrderResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/documents/{documentId}/files/order',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.fileId
     * @param data.requestBody
     * @returns document Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileId(data: PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdData): CancelablePromise<PatchV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/documents/{documentId}/files/{fileId}',
            path: {
                individualId: data.individualId,
                documentId: data.documentId,
                fileId: data.fileId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.fileId
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileId(data: DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdData): CancelablePromise<DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdFilesByFileIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/documents/{documentId}/files/{fileId}',
            path: {
                individualId: data.individualId,
                documentId: data.documentId,
                fileId: data.fileId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.requestBody
     * @returns document Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdDocumentsByDocumentId(data: PatchV1IndividualsByIndividualIdDocumentsByDocumentIdData): CancelablePromise<PatchV1IndividualsByIndividualIdDocumentsByDocumentIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/documents/{documentId}',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdDocumentsByDocumentId(data: DeleteV1IndividualsByIndividualIdDocumentsByDocumentIdData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/documents/{documentId}',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @returns document Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocumentsByDocumentIdCommit(data: PostV1IndividualsByIndividualIdDocumentsByDocumentIdCommitData): CancelablePromise<PostV1IndividualsByIndividualIdDocumentsByDocumentIdCommitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/{documentId}/commit',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.documentId
     * @param data.allowDone
     * @returns preChecksResponse Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdDocumentsByDocumentIdPreChecks(data: PostV1IndividualsByIndividualIdDocumentsByDocumentIdPreChecksData): CancelablePromise<PostV1IndividualsByIndividualIdDocumentsByDocumentIdPreChecksResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/documents/{documentId}/pre-checks',
            path: {
                individualId: data.individualId,
                documentId: data.documentId
            },
            query: {
                allowDone: data.allowDone
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdDocumentsDrafts(data: DeleteV1IndividualsByIndividualIdDocumentsDraftsData): CancelablePromise<DeleteV1IndividualsByIndividualIdDocumentsDraftsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/documents/drafts',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static getV1Individuals(): CancelablePromise<GetV1IndividualsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static postV1Individuals(data: PostV1IndividualsData): CancelablePromise<PostV1IndividualsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualId(data: GetV1IndividualsByIndividualIdData): CancelablePromise<GetV1IndividualsByIndividualIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/',
            path: {
                individualId: data.individualId
            },
            errors: {
                404: 'Response for status 404'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualId(data: PatchV1IndividualsByIndividualIdData): CancelablePromise<PatchV1IndividualsByIndividualIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns string Response for status 200
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualId(data: DeleteV1IndividualsByIndividualIdData): CancelablePromise<DeleteV1IndividualsByIndividualIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/',
            path: {
                individualId: data.individualId
            },
            errors: {
                500: 'Response for status 500'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns string Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdGenerateDescription(data: PostV1IndividualsByIndividualIdGenerateDescriptionData): CancelablePromise<PostV1IndividualsByIndividualIdGenerateDescriptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/generate-description',
            path: {
                individualId: data.individualId
            },
            errors: {
                500: 'Response for status 500'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdRegenStatus(data: GetV1IndividualsByIndividualIdRegenStatusData): CancelablePromise<GetV1IndividualsByIndividualIdRegenStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/regen-status',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdRegenerate(data: PostV1IndividualsByIndividualIdRegenerateData): CancelablePromise<PostV1IndividualsByIndividualIdRegenerateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/regenerate',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdRelation(data: PatchV1IndividualsByIndividualIdRelationData): CancelablePromise<PatchV1IndividualsByIndividualIdRelationResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/relation',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdInviteUser(data: PostV1IndividualsByIndividualIdInviteUserData): CancelablePromise<PostV1IndividualsByIndividualIdInviteUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/invite-user',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns individual Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdRevokeAccess(data: PostV1IndividualsByIndividualIdRevokeAccessData): CancelablePromise<PostV1IndividualsByIndividualIdRevokeAccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/revoke-access',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class TimelineService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns TimelineResponse Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdTimeline(data: GetV1IndividualsByIndividualIdTimelineData): CancelablePromise<GetV1IndividualsByIndividualIdTimelineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/timeline',
            path: {
                individualId: data.individualId
            }
        });
    }
    
}

export class UsersService {
    /**
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static getV1UsersMe(): CancelablePromise<GetV1UsersMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/users/me',
            errors: {
                404: 'Response for status 404'
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static patchV1UsersMe(data: PatchV1UsersMeData): CancelablePromise<PatchV1UsersMeResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/users/me',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Response for status 404'
            }
        });
    }
    
}

export class ThreadsService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns ThreadArray Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdThreads(data: GetV1IndividualsByIndividualIdThreadsData): CancelablePromise<GetV1IndividualsByIndividualIdThreadsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/threads/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdThreads(data: PostV1IndividualsByIndividualIdThreadsData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/threads/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.threadId
     * @returns Thread Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdThreadsByThreadId(data: GetV1IndividualsByIndividualIdThreadsByThreadIdData): CancelablePromise<GetV1IndividualsByIndividualIdThreadsByThreadIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/threads/{threadId}',
            path: {
                individualId: data.individualId,
                threadId: data.threadId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.threadId
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdThreadsByThreadId(data: DeleteV1IndividualsByIndividualIdThreadsByThreadIdData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/threads/{threadId}',
            path: {
                individualId: data.individualId,
                threadId: data.threadId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.threadId
     * @returns Thread Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdThreadsByThreadIdSummerize(data: PostV1IndividualsByIndividualIdThreadsByThreadIdSummerizeData): CancelablePromise<PostV1IndividualsByIndividualIdThreadsByThreadIdSummerizeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/threads/{threadId}/summerize',
            path: {
                individualId: data.individualId,
                threadId: data.threadId
            }
        });
    }
    
}

export class NotesService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns NoteList Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdNotes(data: GetV1IndividualsByIndividualIdNotesData): CancelablePromise<GetV1IndividualsByIndividualIdNotesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/notes/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdNotes(data: PostV1IndividualsByIndividualIdNotesData): CancelablePromise<PostV1IndividualsByIndividualIdNotesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/notes/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns NoteList Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdNotesSearch(data: PostV1IndividualsByIndividualIdNotesSearchData): CancelablePromise<PostV1IndividualsByIndividualIdNotesSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/notes/search',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdNotesByNoteId(data: GetV1IndividualsByIndividualIdNotesByNoteIdData): CancelablePromise<GetV1IndividualsByIndividualIdNotesByNoteIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/notes/{noteId}',
            path: {
                individualId: data.individualId,
                noteId: data.noteId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @param data.requestBody
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdNotesByNoteId(data: PatchV1IndividualsByIndividualIdNotesByNoteIdData): CancelablePromise<PatchV1IndividualsByIndividualIdNotesByNoteIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/notes/{noteId}',
            path: {
                individualId: data.individualId,
                noteId: data.noteId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdNotesByNoteId(data: DeleteV1IndividualsByIndividualIdNotesByNoteIdData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/notes/{noteId}',
            path: {
                individualId: data.individualId,
                noteId: data.noteId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @param data.requestBody
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdNotesByNoteIdTitle(data: PatchV1IndividualsByIndividualIdNotesByNoteIdTitleData): CancelablePromise<PatchV1IndividualsByIndividualIdNotesByNoteIdTitleResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/notes/{noteId}/title',
            path: {
                individualId: data.individualId,
                noteId: data.noteId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @param data.eventId
     * @param data.requestBody
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdNotesByNoteIdEventsByEventId(data: PatchV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdData): CancelablePromise<PatchV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/notes/{noteId}/events/{eventId}',
            path: {
                individualId: data.individualId,
                noteId: data.noteId,
                eventId: data.eventId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.noteId
     * @param data.eventId
     * @returns Note Response for status 200
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdNotesByNoteIdEventsByEventId(data: DeleteV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdData): CancelablePromise<DeleteV1IndividualsByIndividualIdNotesByNoteIdEventsByEventIdResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/notes/{noteId}/events/{eventId}',
            path: {
                individualId: data.individualId,
                noteId: data.noteId,
                eventId: data.eventId
            }
        });
    }
    
}

export class ServiceGroupsService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns ServiceGroupWithGenerationResponseList Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdServiceGroups(data: GetV1IndividualsByIndividualIdServiceGroupsData): CancelablePromise<GetV1IndividualsByIndividualIdServiceGroupsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/service-groups/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.serviceGroupId
     * @returns ServiceGroupWithGenerationResponse Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdServiceGroupsByServiceGroupId(data: PostV1IndividualsByIndividualIdServiceGroupsByServiceGroupIdData): CancelablePromise<PostV1IndividualsByIndividualIdServiceGroupsByServiceGroupIdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/service-groups/{serviceGroupId}',
            path: {
                individualId: data.individualId,
                serviceGroupId: data.serviceGroupId
            }
        });
    }
    
}

export class ErrandsService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns ErrandList Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdErrands(data: GetV1IndividualsByIndividualIdErrandsData): CancelablePromise<GetV1IndividualsByIndividualIdErrandsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/errands/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns Errand Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdErrands(data: PostV1IndividualsByIndividualIdErrandsData): CancelablePromise<PostV1IndividualsByIndividualIdErrandsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/errands/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.errandId
     * @param data.requestBody
     * @returns Errand Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdErrandsByErrandId(data: PatchV1IndividualsByIndividualIdErrandsByErrandIdData): CancelablePromise<PatchV1IndividualsByIndividualIdErrandsByErrandIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/errands/{errandId}',
            path: {
                individualId: data.individualId,
                errandId: data.errandId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.errandId
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdErrandsByErrandId(data: DeleteV1IndividualsByIndividualIdErrandsByErrandIdData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/errands/{errandId}',
            path: {
                individualId: data.individualId,
                errandId: data.errandId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.errandId
     * @returns ErrandActionList Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdErrandsByErrandIdActions(data: GetV1IndividualsByIndividualIdErrandsByErrandIdActionsData): CancelablePromise<GetV1IndividualsByIndividualIdErrandsByErrandIdActionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/errands/{errandId}/actions',
            path: {
                individualId: data.individualId,
                errandId: data.errandId
            }
        });
    }
    
}

export class MunicipalitiesService {
    /**
     * @returns MunicipalityList Response for status 200
     * @throws ApiError
     */
    public static getV1Municipalities(): CancelablePromise<GetV1MunicipalitiesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/municipalities'
        });
    }
    
}

export class FeedbackService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FeedbackResponse Response for status 200
     * @throws ApiError
     */
    public static postV1Feedback(data: PostV1FeedbackData): CancelablePromise<PostV1FeedbackResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/feedback/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class ContactsService {
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @returns ContactList Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdContacts(data: GetV1IndividualsByIndividualIdContactsData): CancelablePromise<GetV1IndividualsByIndividualIdContactsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/contacts/',
            path: {
                individualId: data.individualId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns Contact Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdContacts(data: PostV1IndividualsByIndividualIdContactsData): CancelablePromise<PostV1IndividualsByIndividualIdContactsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/contacts/',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.requestBody
     * @returns Contact Response for status 200
     * @throws ApiError
     */
    public static postV1IndividualsByIndividualIdContactsMerge(data: PostV1IndividualsByIndividualIdContactsMergeData): CancelablePromise<PostV1IndividualsByIndividualIdContactsMergeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/individuals/{individualId}/contacts/merge',
            path: {
                individualId: data.individualId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.contactId
     * @returns Contact Response for status 200
     * @throws ApiError
     */
    public static getV1IndividualsByIndividualIdContactsByContactId(data: GetV1IndividualsByIndividualIdContactsByContactIdData): CancelablePromise<GetV1IndividualsByIndividualIdContactsByContactIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/individuals/{individualId}/contacts/{contactId}',
            path: {
                individualId: data.individualId,
                contactId: data.contactId
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.contactId
     * @param data.requestBody
     * @returns Contact Response for status 200
     * @throws ApiError
     */
    public static patchV1IndividualsByIndividualIdContactsByContactId(data: PatchV1IndividualsByIndividualIdContactsByContactIdData): CancelablePromise<PatchV1IndividualsByIndividualIdContactsByContactIdResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/individuals/{individualId}/contacts/{contactId}',
            path: {
                individualId: data.individualId,
                contactId: data.contactId
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.individualId
     * @param data.contactId
     * @throws ApiError
     */
    public static deleteV1IndividualsByIndividualIdContactsByContactId(data: DeleteV1IndividualsByIndividualIdContactsByContactIdData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/individuals/{individualId}/contacts/{contactId}',
            path: {
                individualId: data.individualId,
                contactId: data.contactId
            }
        });
    }
    
}

export class BillingService {
    /**
     * @throws ApiError
     */
    public static postV1BillingStripeWebhook(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/stripe/webhook'
        });
    }
    
    /**
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static getV1BillingPrices(): CancelablePromise<GetV1BillingPricesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/billing/prices'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static postV1BillingCheckout(data: PostV1BillingCheckoutData): CancelablePromise<PostV1BillingCheckoutResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/checkout',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns unknown Response for status 200
     * @throws ApiError
     */
    public static postV1BillingPortal(data: PostV1BillingPortalData): CancelablePromise<PostV1BillingPortalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/billing/portal',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}